<template>
	<div v-cloak>
		<div class="row">
			<div class="col-md-2 pr-0 py-3 pl-3">
				<div class="d-flex justify-content-between mb-2">
					<span class="text-muted">{{month + ' - ' + year}}</span>
					<div class="dropdown">
						<a class="btn btn-default dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							{{viewName}}
						</a>

						<div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
					    	<a class="dropdown-item" href="#" v-on:click.prevent="setView('D')">
					    		Día
					    		<span class="text-secondary font-weight-bold float-right">
					    			D
					    		</span>
					    	</a>
		        			<a class="dropdown-item" href="#" v-on:click.prevent="setView('W')" v-if="false">
		        				Semana
		        				<span class="text-secondary font-weight-bold float-right">
		        					W
		        				</span>
		        			</a>
		        			<a class="dropdown-item" href="#" v-on:click.prevent="setView('M')">
		        				Mes
		        				<span class="text-secondary font-weight-bold float-right">
		        					M
		        				</span>
		        			</a>
		        			<a class="dropdown-item" href="#" v-on:click.prevent="setView('Y')" v-if="false">
		        				Año
		        				<span class="text-secondary font-weight-bold float-right">
		        					Y
		        				</span>
		        			</a>
		        			<a class="dropdown-item" href="#" v-on:click.prevent="setView('A')" v-if="false">
		        				Agenda
		        				<span class="text-secondary font-weight-bold float-right">
		        					A
		        				</span>
		        			</a>
		        			<a class="dropdown-item" href="#" v-on:click.prevent="setView('X')" v-if="false">
		        				4 días
		        				<span class="text-secondary font-weight-bold float-right">
		        					X
		        				</span>
		        			</a>
					  	</div>
					</div>
				</div>

				<div class="d-flex justify-content-between mb-2">
					<button class="btn btn-default btn-sm" v-on:click.prevent="hoy()">
	    				Hoy
	    			</button>
	    			<div>
		        		<button v-on:click.prevent="subtractMonth()" class="btn btn-default btn-sm">
		        			<i class="fa fa-fw fa-chevron-left"></i>
		        		</button>
		        		<button v-on:click.prevent="addMonth()" class="btn btn-default btn-sm">
			            	<i class="fa fa-fw fa-chevron-right"></i>
		            	</button>
	    			</div>
				</div>

				<div class="mb-3 d-none d-xl-block">
					<div class="p-1">
						<calendario v-model="filters.fecha"></calendario>
					</div>
				</div>

				<!-- Button trigger modal -->
				<button type="button" class="btn btn-sm btn-link" data-toggle="modal" data-target="#filtrosTareas">
				 	Filtros
				</button>
			</div>
			<div class="col-md-10 pl-0">
				<agenda ref="agendaTarea" 
					:estatus="filters.estatus" 
					:sucursal="filters.sucursal" 
					:vendedor="filters.vendedor" 
					:cliente="filters.cliente" 
					:oportunidad="filters.oportunidad" 
					:value="filters.fecha" 
					:usuario="usuario" 
					v-on:updatename="setName($event)"
					v-on:updatemonth="setMonth($event)"
					v-on:updateyear="setYear($event)"></agenda>
			</div>
		</div>

		<!-- Modal -->
		<div class="modal fade" id="filtrosTareas" role="dialog" aria-labelledby="filtrosTareasLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="filtrosTareasLabel">Filtrar tareas</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
		        		</button>
					</div>
					<div class="modal-body">
						<div class="p-1">
							<div class="row">
				                <span class="col">
				                	<label class="text-muted">
				                		<small>Estado:</small>
				                	</label>
				                	<div class="custom-control custom-radio">
										<input type="radio" id="customRadio1" name="customRadio" class="custom-control-input" value="C" v-model="filters.estatus">
										<label class="custom-control-label" for="customRadio1">
									  		Cerradas
									  	</label>
									</div>
									<div class="custom-control custom-radio">
									  	<input type="radio" id="customRadio2" name="customRadio" class="custom-control-input" value="A" v-model="filters.estatus">
									  	<label class="custom-control-label" for="customRadio2">
									  		Abiertas
									  	</label>
									</div>
									<div class="custom-control custom-radio">
									  	<input type="radio" id="customRadio3" name="customRadio" class="custom-control-input" value="" v-model="filters.estatus">
									  	<label class="custom-control-label" for="customRadio3">
									  		Ambas
									  	</label>
									</div>
				                </span>

				                <div class="col-md-12 mb-1">
				                	<label class="text-muted m-0">
				                		<small>Sucursal:</small>
				                	</label>
				                	<catalogo-sucursales v-model="filters.sucursal"></catalogo-sucursales>
				                </div>

				                <div class="col-md-12 mb-1">
				                	<label class="text-muted m-0">
				                		<small>Vendedor:</small>
				                	</label>
				                	<catalogo-vendedores v-model="filters.vendedor"></catalogo-vendedores>
				                </div>

				                <div class="col-md-12 mb-1">
				                	<label class="text-muted m-0">
				                		<small>Cliente:</small>
				                	</label>
				                	<catalogo-clientes v-model="filters.cliente"></catalogo-clientes>
				                </div>

				                <div class="col-md-12 mb-1">
				                	<label class="text-muted m-0">
				                		<small>Oportunidad:</small>
				                	</label>
				                	<catalogo-oportunidades v-model="filters.oportunidad"></catalogo-oportunidades>
				                </div>
				            </div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary"v-on:click="clean()">
							Limpiar
						</button>
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
					</div>
		    	</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props: ['usuario'],
		
		created(){
			this.validateFilters();
		},

		data() {
			return {
				tareas: [],

				modal: {
					title: 'Agregar Tarea',
					button: 'Guardar',
				},

				viewName: '',
				year: '',
				month: '',

				filters: {
					estatus: '',
					sucursal: '',
					vendedor: '',
					cliente: '',
					oportunidad: '',
					fecha: '',
				},

				attrs: [
			        {
			          key: 'today',
			          highlight: {
			            backgroundColor: '#ff8080',
			            // Other properties are available too, like `height` & `borderRadius`
			          },
			          dates: new Date(2018, 0, 1)
			        }
			      ],
			};
		},
		methods: {
			setName: function(data){
				this.viewName = data
			},

			setMonth: function(data){
				this.month = data
			},

			setYear: function(data){
				this.year = data
			},

			clean: function(){
				this.filters.estatus = '';
				this.filters.sucursal = '';
				this.filters.vendedor = '';
				this.filters.cliente = '';
				this.filters.oportunidad = '';
			},

			findGetParameter: function(parameterName) {
		    	var result = null,
		        tmp = [];
		    	location.search
		        	.substr(1)
		        	.split("&")
		        	.forEach(function (item) {
		        tmp = item.split("=");
		        	if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
		        	
		        	});
		    	return result;
			},

			validateFilters: function(){
				var oportunidad = this.findGetParameter('CODIGO_OPORTUNIDAD');
				if (oportunidad) {
					this.filters.oportunidad = oportunidad;
				}

				var cliente = this.findGetParameter('CODIGO_CLIENTE');
				if (cliente) {
					this.filters.cliente = cliente;
				}
			},

			hoy: function(){
				this.$nextTick(() => {
			    	this.$refs.agendaTarea.hoy()
			    })
			},

			subtractMonth: function(){
				this.$nextTick(() => {
			    	this.$refs.agendaTarea.subtractMonth()
			    })
			},

			addMonth: function(){
				this.$nextTick(() => {
			    	this.$refs.agendaTarea.addMonth()
			    })
			},

			setView: function(value){
				this.$nextTick(() => {
			    	this.$refs.agendaTarea.setView(value)
			    })
			}
		},
	}
</script>